import { gql } from '@apollo/client';
import {
  LlmConfigFieldsFragment,
  LlmConversationFieldsFragment,
  UploadEntityFieldsFragment,
} from './fragments';

export const LLM_TEMP_IMAGE_PRE_UPLOAD = gql`
  query llmTempImagePreUpload {
    llmTempImagePreUpload {
      ...UploadEntityFields
    }
  }
  ${UploadEntityFieldsFragment}
`;

export const LLM_CONFIG = gql`
  query llmConfig {
    llmConfig {
      ...LlmConfigFields
    }
  }
  ${LlmConfigFieldsFragment}
`;

export const LLM_SCHEMA_CONVERSATION = gql`
  query llmSchemaConversation($schemaId: String!, $limit: Int! = 100) {
    llmSchemaConversation(schemaId: $schemaId, limit: $limit) {
      ...LlmConversationFields
    }
  }
  ${LlmConversationFieldsFragment}
`;
